import subDomain from '@/config/subSystem-domain.js';
import { isCashierEnv } from '@/utils'

export default {
  install: function(Vue) {
    Vue.mixin({
      data() {
        return {
          subDomain: subDomain
        }
      },

      methods: {
        openMessage(code, message, options = {}) {
          let type;
          switch (code) {
            case 0:
              type = "error";
              break;
            case 1:
              type = "success";
              break;
            case 2:
              type = "info";
              break;
            case 3:
              type = "warning";
              break;
            default:
              break;
          }
          this.$message.closeAll(); // 新的实例出现前先关闭其它现有实例
          this.$message({
            type,
            message,
            showClose: true,
            duration: options.duration || 1500
          });
        },

        openNotify(code, message, title) {
          let type, typeText;
          switch (code) {
            case 0:
              type = "error";
              typeText = "失败";
              break;
            case 1:
              type = "success";
              typeText = "成功";
              break;
            case 2:
              type = "info";
              typeText = "提示";
              break;
            default:
              break;
          }
          this.$notify({
            title: title || typeText,
            message: message,
            type: type
          });
        },

        clearObject(obj) {
          // 清空(不是删除)一个对象的所有属性
          for (var key in obj) {
            obj[key] = "";
          }
        },

        cloneObject(obj) {
          // 深克隆一个对象
          return JSON.parse(JSON.stringify(obj));
        },

        confirm(message, options, sureBack, cancleBack) {
          let defOPtions = {
            title: "系统提示"
          };
          defOPtions = { ...defOPtions, ...options };
          this.$confirm(message, defOPtions)
            .then(() => {
              sureBack && sureBack();
            })
            .catch(() => {
              cancleBack && cancleBack();
            });
        },

        //异步更新队列
        async nextTick(beforeTick, afterTick) {
          beforeTick && beforeTick();
          await this.$nextTick();
          afterTick && afterTick();
        },

        goToUrl() {
          // 如果是收银台，那么跳转收银台
          if (isCashierEnv()) {
            location.href = this.subDomain + '/#/main/cashierList'
            return;
          }
          try {
            location.href = this.subDomain;
          }catch(e) {
            console.error('跳转商户中心发生错误：', e);
            location.assign(this.subDomain);
          }
        }
      }
    });
  }
};
